module.exports = __webpack_public_path__ + "img/training.a544b345.png";